import React from 'react';
import {
  CheckIcon,
  ClockIcon,
  CurrencyDollarIcon,
  TruckIcon,
} from '@heroicons/react/24/outline';
import Header from './app/Header';
import Footer from './app/Footer';
import FooterCopyright from './app/FooterCopyright';
import PlanCards from './app/PlanCards';
import LeadForm from './app/LeadForm';
import { NICHES, SHARED, WHY_CHEAPER, CONTACT_EMAIL } from './utils/product';

const ParaEmpresas = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 bg-mesh-light" aria-hidden="true" />
        <div className="relative container mx-auto px-4 lg:px-6 py-16 lg:py-24">
          <div className="max-w-3xl">
            <span className="badge-brand mb-5">Fretz Empresas</span>
            <h1 className="font-display text-display-xl text-ink-900">
              Rotas mensais para{' '}
              <span className="bg-clip-text text-transparent bg-brand-gradient">substituir a frota própria</span>
            </h1>
            <p className="mt-5 text-xl text-ink-500 leading-relaxed">
              Coleta diária, semanal ou mensal na Grande Goiânia. Pacotes de até {SHARED.maxSize} e {SHARED.maxWeight}.
              A partir de {SHARED.fromPrice}/mês.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#contato" className="btn-primary">Quero Fretz Empresas</a>
              <a href="#plano" className="btn-secondary">Comparar planos</a>
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-ink-50">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="text-center mb-12">
            <p className="eyebrow mb-2">Planos</p>
            <h2 className="font-display text-display-lg text-ink-900">Diário, Semanal e Mensal</h2>
          </div>
          <PlanCards />
        </div>
      </section>

      <section className="section bg-white">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="text-center mb-12 max-w-2xl mx-auto">
            <p className="eyebrow mb-2">Feito para</p>
            <h2 className="font-display text-display-lg text-ink-900">Operações de sacola e pacote</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {NICHES.map((n) => (
              <div key={n.title} className="card p-6">
                <span className="badge-brand">{n.tag}</span>
                <h3 className="font-display text-lg font-bold text-ink-900 mt-4">{n.title}</h3>
                <p className="text-ink-500 mt-2 text-sm leading-relaxed">{n.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-ink-50">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="text-center mb-12">
            <p className="eyebrow mb-2">Economia</p>
            <h2 className="font-display text-display-lg text-ink-900">Por que sai mais barato</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {WHY_CHEAPER.map(({ title, desc }, i) => {
              const Icon = [TruckIcon, ClockIcon, CurrencyDollarIcon][i];
              return (
                <div key={title} className="card p-6">
                  <div className="h-12 w-12 rounded-2xl bg-brand-gradient text-white flex items-center justify-center shadow-glow">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="font-display text-lg font-bold text-ink-900 mt-4">{title}</h3>
                  <p className="text-ink-500 mt-2 text-sm">{desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section id="contato" className="section bg-white">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            <div>
              <h2 className="font-display text-display-lg text-ink-900">Vamos ativar o plano</h2>
              <p className="mt-4 text-ink-500 text-lg leading-relaxed">
                Escreva para {CONTACT_EMAIL} ou envie o formulário. Sem API fictícia, sem simulador de mudança.
              </p>
              <ul className="mt-6 space-y-3">
                {[
                  SHARED.doorRule,
                  `Pacote máximo ${SHARED.maxSize}, ${SHARED.maxWeight}`,
                  `Cobertura: ${SHARED.coverage}`,
                ].map((f) => (
                  <li key={f} className="flex items-start gap-2 text-ink-700">
                    <CheckIcon className="h-5 w-5 text-brand-600 mt-0.5 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>
            <div className="card p-6 lg:p-8">
              <LeadForm id="form-empresas" />
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FooterCopyright />
    </div>
  );
};

export default ParaEmpresas;
